import { Card, Descriptions, Tag } from "antd";
import PropTypes from "prop-types";

const DepartementDetails = ({ departement }) => {
  return (
   <Card>
      <Descriptions column={{sm: 1, lg: 2, xl: 3}}>
        <Descriptions.Item label="Nom">
          {departement?.nom ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Code">
          {departement?.code ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Departement id">
          {departement?.departement_id ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Enabled">
          {departement?.enabled ? (
            <Tag color="success">Actif</Tag>
          ) : (
            <Tag color="error">Inactif</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Personnel id">
          {departement?.personnel_id ?? 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default DepartementDetails;

DepartementDetails.propTypes = {
  departement: PropTypes.object,
};
